<template>
  <div>
    <el-form ref="eqMaForm" :rules="rules" :model="addFormExtend" label-width="120px">
      <el-form-item label="维保任务名称" prop="name">
        <el-input
          v-model="addFormExtend.name"
          placeholder="请输入内容" maxlength="100"
        ></el-input>
      </el-form-item>
      <el-form-item label="维保时间" prop="timeRange">
        <el-time-picker
          is-range
          v-model="addFormExtend.timeRange"
          range-separator="~"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
          @change="handleTimeFormat"
        >
        </el-time-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleAddStandard">新增维保标准</el-button>
      </el-form-item>
      <el-form-item>
        <el-table :data="standardTable" style="width: 100%">
          <el-table-column prop="typeName" label="维保类型" width="180">
          </el-table-column>
          <el-table-column prop="objectTypeName" label="设备设施类型" width="180">
          </el-table-column>
          <el-table-column prop="deviceName" label="设备名称" width="180">
          </el-table-column>
          <el-table-column prop="devicePartName" label="配件名称">
          </el-table-column>
          <el-table-column prop="content" label="维保内容"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="standardTableDeleteRow(scope.$index)"
                type="text"
              >
                移除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <!-- 维保班组 -->
    <!-- 维保任务负责人 -->
    <el-dialog
      title="新增"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form ref="dialogForm" :rules="dialogFormRules" :model="standardForm" label-width="120px">


        <el-form-item label="设备设施类型" prop="objectType">
          <el-radio-group v-model="standardForm.objectType" size="small">
            <el-radio
              v-for="(item, index) in objectTypes"
              :key="index"
              :label="item.dictKey"
              border
              @change="dataChange"
              >{{ item.dictValue }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

            <!-- {
              label: "设备设施类型",
              prop: "objectType",
              type: 'radio',
              value: '1',
              dataType: 'string',
              dicUrl: `/api/blade-system/dict/dictionary?code=object_type`,
              props: {
                label: 'dictValue',
                value: 'dictKey'
              },
              dicData: [],
              span: 24,
            }, -->
        <el-form-item label="维保类型" prop="projectType">
          <el-radio-group v-model="standardForm.projectType" size="small">
            <el-radio
              v-for="(item, index) in upkeepTypes"
              :key="index"
              :label="item.dictKey"
              border
              @change="dataChange"
              >{{ item.dictValue }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-row>
          <el-col span="12">
            <el-form-item label="维保设备" prop="deviceId">
              <el-select
                v-model="standardForm.deviceId"
                placeholder="请选择"
                @change="handleDeviceChange"
              >
                <el-option
                  v-for="item in deviceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12" v-if="standardForm.projectType == 2">
            <el-form-item
              label="维保配件"
              :prop="standardForm.projectType == 2 ? 'devicePartId' : ''"
            >
              <el-select
                v-model="standardForm.devicePartId"
                placeholder="请选择"
                @change="handleDevicePartIdChange"
              >
                <el-option
                  v-for="(item, index) in devicepartList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="维保内容" prop="content">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 8 }"
            placeholder="请输入内容"
            v-model="standardForm.content" maxlength="100"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="cancelAdd">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 维保部门 -->
  </div>
</template>

<script>
import { vString } from "@/util/validate";

import {
  getDictionary,
  getDeviceQueryList,
  getDevicepartQueryList,
} from "@/api/crmedical/order/order-add";
import dayjs from "dayjs";
export default {
  props: ["addFormExtend", "projectId"],
  data() {
    return {
      dialogVisible: false, //新增dialog
      upkeepTypes: [],
      objectTypes:[],
      deviceList: [],
      devicepartList: [],
      //
      standardForm: {
        projectType: "",
        deviceId: "",
        devicePartId: "",
        content: "",
      },
      // 表格数据
      standardTable: [],
      rules: {
        name: [
          { required: true, message: "请输入任务名称", trigger: "change" },
          { validator: vString("任务名称"), trigger: "change" },
        ],
        timeRange: [
          { required: true, message: "请选择维保时间", trigger: "change" },
        ],
      },
      dialogFormRules: {
        projectType: [
          { required: true, message: "请选择维保类型", trigger: "change" },
        ],
        deviceId: [
          { required: true, message: "请选择维保设备", trigger: "change" },
        ],
        devicePartId: [
          { required: true, message: "请选择维保部件", trigger: "change" },
        ],
        content: [
          { required: true, message: "请输入维保内容", trigger: "change" },
          { validator: vString("维保内容"), trigger: "change" },
        ],
      },
    };
  },
  watch: {
    projectId: function () {
      if (this.projectId) {
        console.log('123:=>',123);
        this.deviceList = [];
        this.standardTable = [];
        this.addFormExtend.list = [];
        this.addFormExtend = Object.assign({},this.addFormExtend,{timeRange:''})
        this.addFormExtend = Object.assign({},this.addFormExtend,{name:''})
        this.addFormExtend.upkeepTime = "";
        this.fetchData();
      }
    },
    "standardForm.deviceId": function () {
      if (this.standardForm.deviceId) {
        this.devicepartList = [];
        this.standardForm.devicePartId = "";
        this.standardForm.content = "";
        this.loadDevicepartQueryList();
      }
    },
  },
  methods: {
    validate() {
      return new Promise((res, rej) => {
        this.$refs.eqMaForm.validate((valid) => {
          console.log('444:=>',444);
          console.log('valid:=>',valid);


          if (valid) {
            if (this.addFormExtend.list && this.addFormExtend.list.length > 0) {
              res(true);
            } else {
              this.$message.error("请选择一个标准");
              res(false);
            }
          } else {
            console.log('3333:=>',3333);

            res(false);
          }
        });
      });
    },
    // 标准-弹窗
    handleAddStandard() {
      this.dialogVisible = true;
    },
    // 标准-添加
    confirmAdd() {
      this.$refs.dialogForm.validate((res) => {
        if (res) {
          let tableRow = Object.assign({}, this.standardForm);
          // 获取3个名字用于table展示
          tableRow.typeName = this.getTypeName(tableRow.projectType);
          tableRow.objectTypeName = this.getObjectTypeName(tableRow.objectType);
          tableRow.deviceName = this.getDeviceName(tableRow.deviceId);
          if (tableRow.devicePartId) {
            tableRow.devicePartName = this.getDevicePartName(
              tableRow.devicePartId
            );
          }
          this.standardTable.push(tableRow);
          // 添加数据到addFormExtend
          this.addFormExtend.list = this.standardTable;
          this.cancelAdd();
        }
      });
    },
    cancelAdd() {
      this.dialogVisible = false;
      this.clearAddStandardForm();
      this.$refs.dialogForm.resetFields();
    },

    // 标准列表-删除
    standardTableDeleteRow(index) {
      this.standardTable.splice(index, 1);
    },
    // 新增标准-表单数据清除
    clearAddStandardForm() {
      this.standardForm.projectType = "";
      this.standardForm.deviceId = "";
      this.standardForm.devicePartId = "";
      this.standardForm.content = "";
    },
    // 查找设备名
    getDeviceName(id) {
      let ret = "";
      this.deviceList.forEach((item) => {
        if (item.id == id) {
          ret = item.name;
        }
      });
      return ret;
    },
    getObjectTypeName(id){

      let ret = "";
      this.objectTypes.forEach((item) => {
        if (item.dictKey == id) {
          ret = item.dictValue;
        }
      });
      return ret;
    },
    // 查找设备
    getTypeName(id) {
      let ret = "";
      this.upkeepTypes.forEach((item) => {
        if (item.dictKey == id) {
          ret = item.dictValue;
        }
      });
      return ret;
    },
    getDevicePartName(id) {
      let ret = "";
      this.devicepartList.forEach((item) => {
        if (item.id == id) {
          ret = item.name;
        }
      });
      return ret;
    },
    // 查找设备部件名称
    // 级联更新bug
    // handleDeviceChange(val) {
    //   this.addFormExtend = Object.assign({}, this.addFormExtend, {
    //     deviceId: val,
    //   });
    // },
    // // 级联更新bug
    // handleDevicePartIdChange(val) {
    //   this.addFormExtend = Object.assign({}, this.addFormExtend, {
    //     devicePartId: val,
    //   });
    // },
    // 时间范围格式化
    handleTimeFormat(val) {
      console.log("val:=>", val);
      if (this.addFormExtend.timeRange) {
        let s = dayjs(this.addFormExtend.timeRange[0]).format("HH:mm");
        let e = dayjs(this.addFormExtend.timeRange[1]).format("HH:mm");
        this.addFormExtend.upkeepTime = `${s}~${e}`;
      }
    },
    // 获取维保类型
    loadUpkeepType() {
      getDictionary({ code: "upkeep_type" }).then((res) => {
        console.log("this.upkeepTypes==>", res.data);
        if (res.success) {
          this.upkeepTypes = res.data;
        }
      });
    },
    loadObjectTypesList(){
getDictionary({ code: "device_object_type" }).then((res) => {
        console.log("this.objectTypes==>", res.data);
        if (res.success) {
          // this.upkeepTypes = res.data;
          this.objectTypes = res.data;
        }
      });
    },
    // 获取设备列表
    loadDeviceList() {
      getDeviceQueryList({ projectId: this.projectId }).then((res) => {
        if (res.success) {
          this.deviceList = res.data;
        }
      });
    },
    // 获取设备部件列表
    loadDevicepartQueryList() {
      getDevicepartQueryList({ deviceId: this.standardForm.deviceId }).then(
        (res) => {
          if (res.success) {
            this.devicepartList = res.data;
          }
        }
      );
    },
    fetchData() {
      this.loadUpkeepType();
      this.loadDeviceList();
      this.loadObjectTypesList();
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
<style>
</style>
